export default "__VITE_ASSET__C2Rc8GUg__"